var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoTextWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 20,
    viewBox: "0 0 127 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "REJEEM"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 19.6078V0H8.95467C10.7456 0 12.2847 0.289449 13.5719 0.868348C14.8778 1.44725 15.8852 2.28758 16.5941 3.38936C17.303 4.47246 17.6575 5.76097 17.6575 7.2549C17.6575 8.73016 17.303 10.0093 16.5941 11.0924C15.8852 12.1569 14.8778 12.9785 13.5719 13.5574C12.2847 14.1176 10.7456 14.3978 8.95467 14.3978H3.07817L5.5407 12.0728V19.6078H0ZM12.1168 19.6078L7.24769 12.465H13.1522L18.0493 19.6078H12.1168ZM5.5407 12.6611L3.07817 10.112H8.61887C9.77552 10.112 10.6337 9.85994 11.1933 9.35574C11.7717 8.85154 12.0608 8.15126 12.0608 7.2549C12.0608 6.33987 11.7717 5.63025 11.1933 5.12605C10.6337 4.62185 9.77552 4.36975 8.61887 4.36975H3.07817L5.5407 1.82073V12.6611Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0459 7.59104H37.1405V11.7367H28.0459V7.59104ZM28.4377 15.3221H38.6796V19.6078H22.9529V0H38.3158V4.28571H28.4377V15.3221Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2744 20C46.8379 20 45.532 19.7572 44.3567 19.2717C43.2 18.7675 42.2393 18.0486 41.4744 17.1148L44.4966 13.5294C45.019 14.2017 45.56 14.7152 46.1196 15.07C46.6793 15.4062 47.2669 15.5742 47.8826 15.5742C49.5243 15.5742 50.3451 14.6219 50.3451 12.7171V4.28571H43.5732V0H55.8299V12.381C55.8299 14.9393 55.1862 16.8534 53.899 18.1233C52.6118 19.3744 50.7369 20 48.2744 20Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9012 7.59104H75.9958V11.7367H66.9012V7.59104ZM67.293 15.3221H77.5349V19.6078H61.8082V0H77.1711V4.28571H67.293V15.3221Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9412 7.59104H97.0358V11.7367H87.9412V7.59104ZM88.333 15.3221H98.5749V19.6078H82.8482V0H98.2111V4.28571H88.333V15.3221Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.888 19.6078V0H108.45L116.565 13.3333H114.158L122.049 0H126.611L126.667 19.6078H121.574L121.518 7.7591H122.385L116.481 17.6751H114.018L107.946 7.7591H109.009V19.6078H103.888Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTextWhite);
export default __webpack_public_path__ + "static/media/LogoText-white.93a03f75f7d8cb88558dc4c11389f218.svg";
export { ForwardRef as ReactComponent };